var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('path',{attrs:{"d":"M6.43359 11.4667L15.8669 2.03332L14.3336 0.533325L6.43359 8.43332L2.43359 4.43332L0.933594 5.93332L6.43359 11.4667Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }